module.exports = __webpack_public_path__ + "img/time_keeper_light_with_text.39e8949c.svg";